import {
  STATE_ICON_RUN, STATUS_ICON_CHECK_O, STATUS_ICON_INACTIVE,
  STATUS_ICON_LOADING,
  STATUS_ICON_TIMES_O, STATUS_ICON_WARNING
} from '@/common/utils/statuses';

import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';

export const CREATING_STATUS = 'CREATING';
export const DEPLOYMENT_FAILED_STATUS = 'DEPLOYMENT_FAILED';
export const ACTIVE_STATUS = 'ACTIVE';
export const DISABLED_STATUS = 'DISABLED';
export const CONFIGURING_STATUS = 'CONFIGURING';
export const DELETING_STATUS = 'DELETING';
export const ERROR_STATUS = 'ERROR';

export const LOAD_BALANCER_POOL_STATUSES = {
  CREATING: 'CREATING',
  ACTIVE: 'ACTIVE',
  CONFIGURING: 'CONFIGURING',
  DELETING: 'DELETING',
  ERROR: 'ERROR',
};

export const LOAD_BALANCER_POOL_MEMBER_STATUSES = {
  HEALTHY: 'HEALTHY',
  DISABLED: 'DISABLED',
  UNHEALTHY: 'UNHEALTHY',
  UNKNOWN: 'UNKNOWN',
  ERROR: 'ERROR',
};

export const POOL_STATUS_ICONS = {
  [LOAD_BALANCER_POOL_STATUSES.ERROR]: STATUS_ICON_TIMES_O,
  [LOAD_BALANCER_POOL_STATUSES.CREATING]: STATUS_ICON_LOADING,
  [LOAD_BALANCER_POOL_STATUSES.ACTIVE]: STATE_ICON_RUN,
  [LOAD_BALANCER_POOL_STATUSES.CONFIGURING]: STATUS_ICON_LOADING,
  [LOAD_BALANCER_POOL_STATUSES.DELETING]: STATUS_ICON_LOADING,
};

export const POOL_MEMBER_STATUS_ICONS = {
  [LOAD_BALANCER_POOL_MEMBER_STATUSES.HEALTHY]: STATUS_ICON_CHECK_O,
  [LOAD_BALANCER_POOL_MEMBER_STATUSES.UNHEALTHY]: STATUS_ICON_WARNING,
  [LOAD_BALANCER_POOL_MEMBER_STATUSES.DISABLED]: STATUS_ICON_INACTIVE,
  [LOAD_BALANCER_POOL_MEMBER_STATUSES.ERROR]: STATUS_ICON_TIMES_O,
  [LOAD_BALANCER_POOL_MEMBER_STATUSES.UNKNOWN]: STATUS_ICON_TIMES_O,
};

export const POOL_BALANCING_ALGORITHMS = {
  LEAST_CONNECTIONS: 'LEAST_CONNECTIONS',
  ROUND_ROBIN: 'ROUND_ROBIN',
  SOURCE_IP: 'SOURCE_IP',
};

export const LOAD_BALANCER_POOL_IN_PROGRESS_STATUSES = [
  LOAD_BALANCER_POOL_STATUSES.CREATING,
  LOAD_BALANCER_POOL_STATUSES.CONFIGURING,
  LOAD_BALANCER_POOL_STATUSES.DELETING,
];

export const LOAD_BALANCER_IN_PROGRESS_STATUSES = [CREATING_STATUS, CONFIGURING_STATUS, DELETING_STATUS];

export const LOAD_BALANCER_STATUSES = [
  CREATING_STATUS,
  DEPLOYMENT_FAILED_STATUS,
  ACTIVE_STATUS,
  DISABLED_STATUS,
  CONFIGURING_STATUS,
  DELETING_STATUS,
  ERROR_STATUS
];

export const LOAD_BALANCER_PROTOCOLS = computedLocale(() => ({
  HTTP: i18n.t('HTTP'),
  HTTPS: i18n.t('HTTPS'),
  TCP: i18n.t('TCP'),
  'UDP-CONNECT': i18n.t('UDP'),
  PING: i18n.t('PING')
}));

export const LOAD_BALANCER_POOL_HTTP_HEADERS = [
  'X-Forwarded-For',
  'X-Forwarded-Port',
  'X-Forwarded-Proto'
];

export const LOAD_BALANCER_POOL_SSL_HEADERS = [
  'X-SSL-Client-Verify',
  'X-SSL-Client-Has-Cert',
  'X-SSL-Client-DN',
  'X-SSL-Client-CN',
  'X-SSL-Issuer',
  'X-SSL-Client-SHA1',
  'X-SSL-Client-Not-Before',
  'X-SSL-Client-Not-After'
];

export const POOL_FORWARD_RULE = {
  HTTPS_HTTPS: 'https_https',
  HTTPS_HTTP: 'https_http',
  HTTP_HTTP: 'http_http',
  UDP: 'udp',
  TCP: 'tcp',
};
export const LOADBALANCER_QUOTA_LIMIT = 2000000000;

export const FLAVOR_PROFILE_TOPOLOGY = {
  ACTIVE_STANDBY: 'ACTIVE_STANDBY',
  SINGLE: 'SINGLE'
};

export const LOAD_BALANCER_AMPHORAE_ROLE = {
  STANDALONE: 'STANDALONE',
  MASTER: 'MASTER',
  BACKUP: 'BACKUP'
};
